import { render, staticRenderFns } from "./EmailChangeEmail.vue?vue&type=template&id=4fbfe972&"
import script from "./EmailChangeEmail.vue?vue&type=script&lang=js&"
export * from "./EmailChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports